import { act_awd } from '@lc/action/cardType/Award';
import { act_com } from '@lc/action/cardType/Common';
// import { AwardMeta } from '@lc/card/meta/ss/AwardMeta';
import { createCardAwardVerbose } from '@lc/interface/card/award/factory';
import { Award } from '@lc/interface/card/award/types';
import { GameState } from '@lc/interface/gameState/types';

// TODO add a "target Id" to... no we need to have an interactive messaging point during award and contract resolution
export const getAwardVerbose = (AwardMeta: Award[]) => [
	createCardAwardVerbose(
		AwardMeta[0],
		(
			playerData: any,
			gameState: GameState // 0 puppy bowl
		) => act_awd.giveNeighborsCFperB(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_awd.setTargetArrToNeighbors(playerData, gameState),
		(
			playerData: any,
			gameState: GameState // 0 MAKE THE BEST COMMERCIAL DURING THE PUPPY BOWL
		) => act_awd.puppyBowl(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[1],
		(
			playerData: any,
			gameState: GameState // 1 PARTICIPATION TROPHY
		) => act_awd.participationTrophy(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 1 PARTICIPATION TROPHY
		) => act_awd.participationTrophy(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[2],
		(
			playerData: any,
			gameState: GameState // 2 WIN ‘AMERICA’S GOT POWER’
		) => act_awd.americaPower(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 2 WIN ‘AMERICA’S GOT POWER’
		) => act_awd.americaPower(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[3],
		(
			playerData: any,
			gameState: GameState // 3 ENERGY ENTREPRENEUR OF THE YEAR
		) => act_awd.stealBattery(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_awd.setTargetArrToNeighbors(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_awd.entrepreneur(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[4],
		(
			playerData: any, // CHOOSE NEIGHBOR TO DROP CARBON FOOTPRINT INTO
			gameState: GameState // 4 LEAVE NO TRACE
		) => act_com.giveFootprint(playerData, gameState) // TODO needs trigger step on award resolution
	),
	createCardAwardVerbose(
		AwardMeta[5],
		(
			playerData: any, // CHOOSE NEIGHBOR TO DROP CARBON FOOTPRINT INTO
			gameState: GameState // 5 FREE PEDICURE
		) => act_com.giveFootprint(playerData, gameState) // TODO needs trigger step on award resolution
	),
	createCardAwardVerbose(
		// TODO change to "DISTRIBUTE YOUR CARBON FOOTPRINT TO *A NEIGHBORS* FOOTPRINT OR..."
		AwardMeta[6],
		(
			playerData: any, // EITHER: Distribute via a tally OR Steal a battery
			gameState: GameState // 6 JUMP STARTER
		) => act_awd.stealBattery(playerData, gameState) // requires decision and resolution function. You can cut down this card to be simpler too.
	),
];
